export default "__VITE_ASSET__DxItHBxM__"